'use client';

import { useFavorites, useInFavorites } from '@/features/favorites';
import ArrowIcon from '@/shared/assets/arrow.svg?svg';
import HeartIcon from '@/shared/assets/heart_filled.svg?svg';
import { Box, Button, Text } from '@/shared/ui';
import { shareThroughtNavigator } from '@/shared/utils/share';
import styles from './Article.module.css';

interface ControlsProps {
  articleId: string;
  description?: string;
}

export const Controls = ({ articleId, description }: ControlsProps) => {
  const isFavorite = useInFavorites(articleId);

  const add = useFavorites((state) => state.addArticle);

  const remove = useFavorites((state) => state.removeArticle);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      paddingTop={18}
      paddingBottom={20}
      gap={4}
    >
      <Button
        className={styles.control}
        onClick={() => (!isFavorite ? add(articleId) : remove(articleId))}
        data-active={isFavorite}
      >
        <HeartIcon width={28} height={28} />
        <Text
          fontSize={14}
          fontWeight={600}
          lineHeight="140%"
          letterSpacing={0.2}
          color="black"
        >
          {isFavorite ? 'Сохранено' : 'В избранное'}
        </Text>
      </Button>
      <Button
        className={styles.control}
        onClick={() =>
          shareThroughtNavigator(window.location.href, description ?? null)
        }
      >
        <ArrowIcon width={28} height={28} />{' '}
        <Text
          fontSize={14}
          fontWeight={600}
          lineHeight="140%"
          letterSpacing={0.2}
          color="black"
        >
          Поделиться
        </Text>
      </Button>
    </Box>
  );
};
